<template>
  <div
    style="position: relative; width: 100%; height: 100%;"
    class="all-center"
  >
    <div
      v-show="loading"
      style="
        z-index: 1;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 200px;
        height: 200px;
        background: white;
      "
      class="all-center"
    >
      <v-progress-circular :size="50" :width="5" indeterminate color="primary">
      </v-progress-circular>
    </div>
    <v-lazy style="width: 200px; height: 205px;">
      <StructureViewer
        @closeLoading="changeLoading"
        :index="index"
        :struct="struct"
        :width="200"
        :height="200"
      >
      </StructureViewer>
    </v-lazy>
  </div>
</template>

<script>
import StructureViewer from "./StructureViewer.vue";
export default {
  name: "listLoading",
  data() {
    return {
      loading: true,
    };
  },
  components: {
    StructureViewer,
  },
  props: {
    width: Number, //宽度
    height: Number, //高度
    struct: Object, //结构文件数据
    index: Number, //多个viewer同时存在于页面时的标识
  },
  methods: {
    changeLoading() {
      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
